import React from 'react';
import classes from './Loaders.module.scss'

const LoadingSpinner = () => {
    return (
        <div className={classes.loadingSpinner__container}>
            <div className={classes.loadingSpinner}></div>
        </div>
    );
};

export default LoadingSpinner;